class FilterTags {
  constructor(options = {}) {
    this.config = {
      module: document.querySelectorAll('[data-module="filter-tag"]'),
      ...options
    };
  }

  init() {
    const { module } = this.config;

    module.forEach(tag => {
      tag.addEventListener('click', e => {
        e.preventDefault();

        const item = tag.dataset;
        const updatedParams = FilterTags.deleteItemParams(item);

        if (updatedParams.length) {
          window.location.href = `?${updatedParams}`;
          return;
        }
        window.location.href = `${window.location.protocol}//${window.location.host}${
          window.location.pathname
        }`;
      });
    });
  }

  static deleteItemParams(item) {
    const { key, name } = item;
    const currentParameters = FilterTags.getUrlParams();
    const paramaterValues = currentParameters[key].split(',');
    const filteredParameterValues = paramaterValues.filter(x => x !== name);

    currentParameters[key] = filteredParameterValues.join(',');

    if (!currentParameters[key].length) {
      delete currentParameters[key];
    }

    const queryString = Object.keys(currentParameters)
      .map(keyName => `${keyName}=${encodeURIComponent(currentParameters[keyName])}`)
      .join('&');

    return queryString;
  }

  static getUrlParams() {
    const url = window.location.search;
    const hashes = url.slice(url.indexOf('?') + 1).split('&');
    const params = {};
    hashes.forEach(hash => {
      const [key, val] = hash.split('=');
      params[key] = decodeURIComponent(val);
    });
    return params;
  }
}

export default FilterTags;
